import React from "react"


class Users extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <section>

                

            </section>
        )
    }

}

export default Users


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/Users.js